import { ApiSmpPage, FailureApi } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "smp.page";

type Params = Parameters<typeof ApiSmpPage.retrieveByExternalId>[0];
type Response = Await<ReturnType<typeof ApiSmpPage.retrieveByExternalId>>;

export const useQuerySmpPage = (
  params: Params,
  options?: Omit<
    UseQueryOptions<Response, FailureApi>,
    "queryKey" | "queryFn" | "select"
  >,
) =>
  useQuery<Response, FailureApi>(
    [KEY, params],
    () => ApiSmpPage.retrieveByExternalId(params),
    options,
  );

useQuerySmpPage.KEY = KEY;
